import React from 'react'
import { connect } from 'react-redux'
import _ from 'lodash'

const IfAnyGranted = props => {
  if (_.intersection(props.roles, props.auth.user.roles).length > 0) {
    return props.children
  }
  return null
}

export default connect(({ auth }) => ({ auth }))(IfAnyGranted)



// WEBPACK FOOTER //
// ./src/components/templates/route-management/IfAnyGranted.js